import { render, staticRenderFns } from "./dialogExchangeGoods.vue?vue&type=template&id=f9966a08&scoped=true&"
import script from "./dialogExchangeGoods.vue?vue&type=script&lang=js&"
export * from "./dialogExchangeGoods.vue?vue&type=script&lang=js&"
import style0 from "./dialogExchangeGoods.vue?vue&type=style&index=0&id=f9966a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9966a08",
  null
  
)

export default component.exports